import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { t } from "i18next";
import swal from "sweetalert";
import {
  InputText,
  Form,
  Button,
  Col,
  Row,
  Checkbox,
  Spin,
  Breadcrumb,
  Typography,
  Card,
  SelectInput,
  NumberInput,
} from "common/elements";
import {
  updateRecordById,
  getOne,
  getPermission
} from "services/role";
import { clearAllSesionEmployee } from "services/employee";

const { Title } = Typography;

const RoleUpdate = () => {
  const [permissions, setPermissions] = useState([]);
  const [roles, setRoles] = useState([]);
  const [role, setRole] = useState({});
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    setLoading(true);
    getOne(id)
      .then((response) => {
        if (
          response &&
          response.data &&
          Array.isArray(response.data.permissions)
        ) {
          const data = response.data;
          form.setFieldsValue({
            name: data.name,
            code: data.code,
            order: data.order,
          });
          const newPermissions = data.permissions.map((value) => {
            const rolePermission = value.rolePermission[0];
            return {
              id: rolePermission["id"],
              permissionId: value.id,
              status: rolePermission["status"],
            };
          });
          setRole(data);
          setPermissions(newPermissions);
          // api permission from role
          getPermission().then((response) => {
            if (response && response.data) {
              setRoles(response.data);
            }
          });
        }
      }).catch(error => {
        if (error.response.status === 403) {
          localStorage.removeItem("ACCESS_TOKEN");
          navigate("/signin");
        }
      })
      .finally(() => {
        setLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  const goBack = () => {
    navigate("/setting/role");
  };

  const onFinish = (values) => {
    values.permissionRole = permissions;
    setLoadingButton(true);
    setDisabled(true);

    clearAllSesionEmployee(id);
    updateRecordById(id, values)
      .then(() => {
        goBack();
      })
      .catch(error => {
        swal({
          title: "Opps!",
          text: error?.response?.data?.error?.message,
          icon: "error",
          dangerMode: true,
       });
      })
      .finally(() => {
        setLoadingButton(false);
        setDisabled(false);
      });
  };

  const checkStatus = (key, id) => {
    const foundPermission = role.permissions.find(
      (value) => value.id === id && value.key === key
    );

    if (foundPermission) {
      return foundPermission.rolePermission[0]["status"];
    } else {
      const foundIndex = permissions.findIndex(
        (value) => value.permissionId === id
      );
      if (foundIndex < 0) {
        permissions.push({ permissionId: id, status: false });
        setPermissions([...permissions]);
      }
      return false;
    }
  };

  const onchangeCheckBox = (id) => {
    const foundPermission = permissions.find(
      (value) => value.permissionId === id
    );
    if (foundPermission) {
      foundPermission.status = !foundPermission.status;
    }
    setPermissions([...permissions]);
  };

  const handleCancel = () => {
    goBack();
  };

  return (
    <>
  
      <Breadcrumb className="beadcrumb-role" style={{marginBottom: "15px"}}>
        <Breadcrumb.Item id="beadcrumb-title">
          {t("text_roles")}
        </Breadcrumb.Item>
        <Breadcrumb.Item id="beadcrumb-subtitle">
          {t("text_update_role")}
        </Breadcrumb.Item>
      </Breadcrumb>
      <div id="role">
      {loading ? (
        <Spin
          spinning={loading}
          style={{ display: "flex", alignItems: "center", height: "85%" }}
        />
      ) : (
        <Form
          onFinish={onFinish}
          form={form}
          layout="vertical"
          id="role-form"
        >
          <InputText
            name="name"
            label={t("text_name")}
            placeholder={t("text_name")}
            requiredMessage={t("text_please_input_role_name")}
          />

          <SelectInput
            name={"code"}
            label={t("text_base_role")}
            placeholder={t("text_select_base_role")}
            required={true}
            errorMessage={t("text_please_select_base_role")}
            valueKey="id" 
            dataSource={[
                { id: "FIFTH_LINE_MANAGER",name: t("text_5th_line_manager")},
                { id: "FOURTH_LINE_MANAGER",name: t("text_4th_line_manager")},
                // { id: "HR_MANAGER",name: t("text_hr_manager")},
                { id: "THIRD_LINE_MANAGER", name: t("text_3rd_line_manager") }, 
                { id: "SECOND_LINE_MANAGER", name: t("text_2nd_line_manager") },  
                { id: "FIRST_LINE_MANAGER", name: t("text_1st_line_manager") },     
                { id: "STAFF", name: t("text_general_staff") },           
                { id: "GUARD", name: t("text_guard") }
              ]}
            /> 
           <NumberInput
              name="order"
              label={t("text_order")}
              placeholder={t("text_order")}
              isAutoSelect={true}
            />  
          <Row>
            <Title level={5}>{t("text_permissions")}</Title>
          </Row>
          <Row gutter={[16, 16]} id="role-card">
            {roles.length > 0 &&
              roles.map((role, index) => (
                <Col span={6} key={index} offset={-2}>
                  <Card title={role.module} size="small" id="width-card">
                    <ul>
                      {role.children.map((child, index) => (
                        <li key={index} style={{textTransform: "capitalize"}}>
                          <Checkbox
                            onChange={() => onchangeCheckBox(child.id)}
                            defaultChecked={checkStatus(child.key, child.id)}
                          >
                            {child.key}
                          </Checkbox>
                        </li>
                      ))}
                    </ul>
                  </Card>
                </Col>
              ))}
          </Row>
          <Row  style={{display: 'flex',justifyContent: "center"}}>
          <div className="ant-modal-footer2">
              <Button
                className="btn-cancel"
                onClick={handleCancel}
                disabled={disabled}
              >
                {t("text_cancel")}
              </Button>
              <Button
                className="btn-save"
                type="primary"
                htmlType="submit"
                loading={loadingButton}
              >
                {t("text_save")}
              </Button>
            </div>
          </Row>     
        </Form>
      )}
    </div>
    </>
  );
};
export default RoleUpdate;
